import { Icon } from '@ritualco/jutsu'

export const DragHandleIcon = (props: any) => (
  <Icon viewBox="0 0 25 25" color="grayscale.quaternary" {...props}>
    <path
      d="M9.36328 4.34338C8.26328 4.34338 7.36328 5.24338 7.36328 6.34338C7.36328 7.44338 8.26328 8.34338 9.36328 8.34338C10.4633 8.34338 11.3633 7.44338 11.3633 6.34338C11.3633 5.24338 10.4633 4.34338 9.36328 4.34338Z"
      fill="currentColor"
    />
    <path
      d="M7.36328 12.3434C7.36328 11.2434 8.26328 10.3434 9.36328 10.3434C10.4633 10.3434 11.3633 11.2434 11.3633 12.3434C11.3633 13.4434 10.4633 14.3434 9.36328 14.3434C8.26328 14.3434 7.36328 13.4434 7.36328 12.3434Z"
      fill="currentColor"
    />
    <path
      d="M9.36328 20.3434C10.4633 20.3434 11.3633 19.4434 11.3633 18.3434C11.3633 17.2434 10.4633 16.3434 9.36328 16.3434C8.26328 16.3434 7.36328 17.2434 7.36328 18.3434C7.36328 19.4434 8.26328 20.3434 9.36328 20.3434Z"
      fill="currentColor"
    />
    <path
      d="M17.3633 6.34338C17.3633 7.44338 16.4633 8.34338 15.3633 8.34338C14.2633 8.34338 13.3633 7.44338 13.3633 6.34338C13.3633 5.24338 14.2633 4.34338 15.3633 4.34338C16.4633 4.34338 17.3633 5.24338 17.3633 6.34338Z"
      fill="currentColor"
    />
    <path
      d="M15.3633 10.3434C14.2633 10.3434 13.3633 11.2434 13.3633 12.3434C13.3633 13.4434 14.2633 14.3434 15.3633 14.3434C16.4633 14.3434 17.3633 13.4434 17.3633 12.3434C17.3633 11.2434 16.4633 10.3434 15.3633 10.3434Z"
      fill="currentColor"
    />
    <path
      d="M13.3633 18.3434C13.3633 17.2434 14.2633 16.3434 15.3633 16.3434C16.4633 16.3434 17.3633 17.2434 17.3633 18.3434C17.3633 19.4434 16.4633 20.3434 15.3633 20.3434C14.2633 20.3434 13.3633 19.4434 13.3633 18.3434Z"
      fill="currentColor"
    />
  </Icon>
)
